import { RecommendationFeature } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { declaredExperimentsField, useDeclaredExperiments } from './declaredExperiments';
import { useDisplayPrices } from './useDisplayPrices';
import { useMatchingLabels } from './useMatchingLabels';
import { isLazyPricesEnabled } from './useRecommendations';
import { useResultsPageOfferingsBi } from './useResultsPageOfferingsBi';
export const PRE_SUGGESTIONS_FALLBACK_QUERY = 'mystunningwebsite';
export const usePreSuggestions = function (fallbackQuery) {
  if (fallbackQuery === void 0) {
    fallbackQuery = PRE_SUGGESTIONS_FALLBACK_QUERY;
  }
  const isLazyPrices = isLazyPricesEnabled();
  const experimentIds = useDeclaredExperiments();
  const {
    data,
    isLoading,
    error
  } = DomainsApiClient.hooks.useListRecommendations({
    query: fallbackQuery,
    features: [...(isLazyPrices ? [] : [RecommendationFeature.PRICING]), RecommendationFeature.USE_BUSINESS_INFO],
    paging: {
      limit: 3
    },
    // This hook keys its cache on the request, so the new field varies it on its own.
    ...declaredExperimentsField(experimentIds)
  }, true, {
    cacheTime: Infinity,
    staleTime: Infinity,
    useErrorBoundary: false
  });
  const baseRecommendations = (data == null ? void 0 : data.recommendations) ?? [];
  const {
    pricesByDomain,
    isLoading: isPricingLoading
  } = useDisplayPrices(isLazyPrices ? baseRecommendations : []);
  const recommendations = isLazyPrices ? baseRecommendations.map(recommendation => recommendation.domain && pricesByDomain.has(recommendation.domain) ? {
    ...recommendation,
    price: pricesByDomain.get(recommendation.domain)
  } : recommendation) : baseRecommendations;
  useResultsPageOfferingsBi({
    recommendations: baseRecommendations,
    isLoading
  });
  const {
    resolveActionForSuggestion
  } = DomainSearchSuiteModule.SDK.useSuggestionActionResolver();
  const {
    data: purchasePermissions
  } = DomainsApiClient.hooks.useGetPurchasePermissions({});
  const {
    labels: matchLabels,
    isLoading: isLoadingLabels
  } = useMatchingLabels(recommendations);
  const onGetItClick = async recommendation => {
    const position = recommendations.findIndex(_ref => {
      let {
        id
      } = _ref;
      return id === recommendation.id;
    });
    DomainSearchSuiteModule.internals.bi.onGetItClick == null || DomainSearchSuiteModule.internals.bi.onGetItClick({
      domain: recommendation.domain || '',
      type: recommendation.label,
      position
    });
    if (recommendation.domain) {
      await resolveActionForSuggestion(recommendation.domain);
    }
  };
  return {
    recommendations,
    isLoading,
    isPricingLoading,
    matchLabels,
    isLoadingLabels,
    disabled: !(purchasePermissions != null && purchasePermissions.hasPermission),
    hidden: Boolean(error) || !isLoading && !baseRecommendations.length,
    onGetItClick
  };
};
//# sourceMappingURL=usePreSuggestions.js.map